module.exports = __webpack_public_path__ + "static/media/sma.703448d1.webp";